import React, { useRef, useEffect, useState } from 'react';
import { TimePicker as RainbowTimePicker, Application } from 'react-rainbow-components';
import './style.css';

const containerStyles = {
  maxWidth: 400,
  display: 'none',
};

type Props = {
  value: string | null;
  setValue: (value: string) => void;
  label?: string;
  formatStyle?: 'large' | 'medium' | 'small';
  isDisabled?: boolean;
  error?: {
    valid: boolean;
    message: string;
  };
  hideValidation?: boolean;
};

const theme = {
  rainbow: {
    palette: {
      brand: '#FEC307',
    },
  },
};

const TimePicker: React.FC<Props> = ({ value, setValue, label = 'Time', formatStyle = 'large', isDisabled, error, hideValidation }) => {
  const timePickerRef = useRef(null);

  const testResult = !error ? 'valid' : error.valid ? 'valid' : 'invalid';
  const inputClass = `is-${testResult}`;
  const labelClass = `${testResult}-feedback`;

  const openModal = () => {
    if (timePickerRef.current && !isDisabled) {
      const timePicker = timePickerRef.current;
      if (timePicker) {
        timePicker.click();
      }
    }
  };

  useEffect(() => {
    if (value) {
      const formattedTime = formatTime(value);
      setFormattedValue(formattedTime);
    } else {
      setFormattedValue('');
    }
  }, [value]);

  const [formattedValue, setFormattedValue] = useState('');

  const formatTime = (timeString: string) => {
    const [hours, minutes] = timeString.split(':');
    const parsedHours = parseInt(hours, 10);
    const period = parsedHours >= 12 ? 'PM' : 'AM';
    const formattedHours = parsedHours % 12 || 12;
    return `${formattedHours}:${minutes} ${period}`;
  };

  return (
    <Application theme={theme}>
      <div className="time-picker-container">
        <div className="form-floating">
          <input
            type="text"
            name={'time-picker'}
            id={'time-picker'}
            className={`form-control ${hideValidation ? "" : inputClass}`}
            placeholder="Time"
            value={formattedValue}
            readOnly
            onClick={openModal}
            disabled={isDisabled}
          />

          <label htmlFor="time-picker" className={`floating`}>
            {label}
          </label>
          {error && !error?.valid && <span className={labelClass}>{error?.message}</span>}
        </div>
        <div
          className="rainbow-align-content_center rainbow-m-vertical_large rainbow-p-horizontal_small rainbow-m_auto time time-picker-container"
          style={containerStyles}
        >
          <RainbowTimePicker
            className="time-picker-container"
            ref={timePickerRef}
            label={label}
            value={value}
            onChange={(newTime) => {
              const formattedTime = formatTime(newTime);
              setFormattedValue(formattedTime);
              setValue(newTime);
            }}
            borderRadius="semi-square"
          />
        </div>
      </div>
    </Application>
  );
};

export default TimePicker;
